import React from 'react';
import {Button as PrimeButton} from 'primereact/button';
import {classNames} from 'primereact/utils';
import './Button.scss';

interface ButtonProps {
  label?: string;
  icon?: string;
  iconPos?: 'left' | 'right' | 'top' | 'bottom';
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info';
  size?: 'small' | 'normal' | 'large';
  outlined?: boolean;
  text?: boolean;
  raised?: boolean;
  rounded?: boolean;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children?: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
}

const Button: React.FC<ButtonProps> = ({
  label,
  icon,
  iconPos = 'left',
  variant = 'primary',
  size = 'normal',
  outlined = false,
  text = false,
  raised = false,
  rounded = false,
  loading = false,
  disabled = false,
  className,
  onClick,
  children,
  type = 'button',
}) => {
  const buttonClass = classNames(
    'custom-button',
    `custom-button--${variant}`,
    `custom-button--${size}`,
    {
      'custom-button--outlined': outlined,
      'custom-button--text': text,
      'custom-button--raised': raised,
      'custom-button--rounded': rounded,
    },
    className,
  );

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    // Only prevent default if it's not a submit button in a form
    if (type !== 'submit') {
      e.preventDefault();
    }
    if (onClick && !disabled && !loading) {
      onClick(e);
    }
  };

  return (
    <PrimeButton
      label={label}
      icon={icon}
      iconPos={iconPos}
      className={buttonClass}
      loading={loading}
      disabled={disabled}
      onClick={handleClick}
      type={type}
      outlined={outlined}
      text={text}
      raised={raised}
      rounded={rounded}
    >
      {children}
    </PrimeButton>
  );
};

export default Button;
